import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Tabs } from "components/Tabs";
import { Heading } from "style/components/Heading.styles";
import { PartnershipsContainer } from "./Partnerships.styles";
import { MobyTab } from "./Tabs/Moby";
import { QuiverTab } from "./Tabs/Quiver";

const TabOptions = [
  { key: "moby", name: "Moby" },
  { key: "quiver", name: "Quiver" },
];

export const Partnerships = () => {
  const [activeTab, setActiveTab] = useState("moby");

  const handleTabClick = (filter) => {
    setActiveTab(filter.key);
  };

  return (
    <PartnershipsContainer>
      <Row>
        <Col md={12}>
          <section className="partnerships-content">
            <Heading>Partnerships</Heading>
            <div className="divider mt-1 mb-1"></div>
            <Tabs
              options={TabOptions}
              handleTabClick={handleTabClick}
              showDivider={false}
            />

            <div className="tab-content">
              {activeTab === "moby" && <MobyTab />}
              {activeTab === "quiver" && <QuiverTab />}
            </div>
          </section>
        </Col>
      </Row>
    </PartnershipsContainer>
  );
};
